// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container__Gp1Rv","tagList":"Tags_tagList__Z9Bd2"};